/* eslint-disable no-console */
/* global MobileApp:false */

import { isFunction } from 'lodash';
import log from '@/logger';
import { iOSWrapper } from '@/mixins/userAgent';

export default {
  userLoggedIn(token) {
    if (iOSWrapper) {
      window.location.href = `pred://userLoggedIn?token=${token}`;
    } else {
      if (typeof MobileApp === 'undefined') return;
      if (!isFunction(MobileApp.userLoggedIn)) return;
      try {
        MobileApp.userLoggedIn.bind(MobileApp)(token);
      } catch (err) {
        log.error(err);
      }
    }
  },
  userLoggedOut() {
    if (iOSWrapper) {
      window.location.href = 'pred://userLoggedOut';
    } else {
      if (typeof MobileApp === 'undefined') return;
      if (!isFunction(MobileApp.userLoggedOut)) return;
      try {
        MobileApp.userLoggedOut.bind(MobileApp)();
      } catch (err) {
        log.error(err);
      }
    }
  },
};
